var React = require('react');
var Link = require('react-router').Link;
var GUIDE = require('../stake-guide');
var inlineLinks = require('../inline-links');
var SiteFooter = require('../site-footer');

function rich(text, key) {
  return inlineLinks(text).map(function(part, i) {
    if (typeof part === 'string') return part;
    if (part.href.charAt(0) === '#') return <a key={key + '-' + i} href={part.href}>{part.label}</a>;
    if (part.href.indexOf('/go/') === 0 || /^https?:/.test(part.href)) {
      var go = part.href.indexOf('/go/') === 0;
      return <a key={key + '-' + i} href={part.href} rel={go ? 'sponsored nofollow' : 'nofollow noopener'} className={go ? 'stake-guide-cta' : null}>{part.label}</a>;
    }
    return <Link key={key + '-' + i} to={part.href}>{part.label}</Link>;
  });
}

function cta(c, key) {
  if (!c) return null;
  return <p className="stake-cta-wrap" key={key}><a className="cta-button stake-cta" href={c.href} rel="sponsored nofollow">{c.label}</a></p>;
}

function block(sec, key) {
  return (
    <div key={key}>
      {(sec.p || []).map(function(p, i) { return <p key={i}>{rich(p, key + 'p' + i)}</p>; })}
      {sec.list ? <ul className="stake-guide-list">{sec.list.map(function(li, i) { return <li key={i}>{rich(li, key + 'l' + i)}</li>; })}</ul> : null}
    </div>
  );
}

var GuideStakeUs = React.createClass({
  componentDidMount: function() { document.title = GUIDE.title; },
  componentWillUnmount: function() {
    document.title = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';
  },
  render: function() {
    return (
      <article className="content-page guide-page stake-guide">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">{GUIDE.h1}</h1>
        <p className="content-lead">{rich(GUIDE.lead, 'lead')}</p>
        {cta(GUIDE.leadCta, 'leadcta')}
        {GUIDE.sections.map(function(sec, i) {
          return (
            <section key={sec.h} id={sec.id}>
              <h2>{sec.h}</h2>
              {block(sec, 's' + i)}
              {(sec.sub || []).map(function(sub, j) {
                return <div key={sub.h}><h3>{sub.h}</h3>{block(sub, 's' + i + 'u' + j)}</div>;
              })}
              {cta(sec.cta, 'cta' + i)}
            </section>
          );
        })}
        <section className="faq-list">
          <h2>Stake.us FAQ</h2>
          {GUIDE.faq.map(function(item) {
            return <div className="faq-item" key={item.q}><h3>{item.q}</h3><p>{item.a}</p></div>;
          })}
          {cta(GUIDE.faqCta, 'faqcta')}
        </section>
        <p className="stake-guide-disclaimer">{GUIDE.disclaimer}</p>
        <p className="home-intro-links">Sources: {GUIDE.sources.map(function(s, i) {
          return <span key={s[1]}>{i ? ' · ' : ''}<a href={s[1]} rel="nofollow noopener">{s[0]}</a></span>;
        })}</p>
        <p className="home-intro-links">Questions about this guide: info@dailytourneys.com · <Link to="/guides/poker-tournament-faq">Poker tournament FAQ</Link></p>
        <SiteFooter />
      </article>
    );
  }
});

module.exports = GuideStakeUs;



// WEBPACK FOOTER //
// ./js/pages/guide-stake-us.jsx